import { auth } from '../../../auth/i18n/en';
import { dashboard } from '../../../dashboard/i18n/en';
import footer from './assets/footer.json';
import notFound from './assets/notfound.json';

export const en = {
  translation: {
    auth,
    dashboard,
    footer,
    notFound,
  },
};
